<template>
  <div class="recruit">
    <div class="banner_box">
      <Banner></Banner>
    </div>
    <div style="padding: 0.1042rem 1.875rem;">
      <div class="title_box">加入我们</div>
      <div class="recruit_box">
        <div class="recruit_li">
          <div class="info"
               @click="dialogVisible = true">查看详情</div>
          <div class="title">
            UI设计
          </div>
          <p>
            1、负责公司产品的界面进行设计、编辑、美化等工作；<br>
            3、对公司的宣传产品进行美工设计；<br>
            4、负责客户及系统内的广告和专题的设计；<br>
            5、负责与开发人员配合完成所辖网站等前台页面设计和编辑；<br>
            6、其他与美术设计相关的工作。
          </p>
        </div>
        <div class="recruit_li">
          <div class="info"
               @click="dialogVisible = true">查看详情</div>
          <div class="title">
            Java开发工程师
          </div>
          <p>
            1、负责系统开发、PC端网站维护、手机APP接口开发、移动端网<br>
            2、独立完成关键功能模块的设计和开发工作；<br>
            3、系统功能模块的开发及测试工作；<br>
            4、独立的技术开发能力；<br>
            5、3年以上java开发经验；
          </p>
        </div>
        <div class="recruit_li">
          <div class="info"
               @click="dialogVisible = true">查看详情</div>
          <div class="title">
            web开发工程师
          </div>
          <p>
            1、工作内容主要是微商城、在线支付、会员系统的开发，包括公众号、小程序、uniAPP等。<br>
            2、配合后端完成接口调试，有前后端分离开发经验。<br>
            3、熟悉面向组件的前端开发模式，对组件规划、封装及APP上架工作有相关经验。
          </p>
        </div>
        <div class="recruit_li">
          <div class="info"
               @click="dialogVisible = true">查看详情</div>
          <div class="title">
            市场业务销售
          </div>
          <p>
            1、产品的市场推广与销售工作；<br>
            2、产品品牌的市场宣传与良好口碑的建立；<br>
            3、多渠道开发、积累客户，为产品销售开拓更大市场；<br>
            4、筛选有意向客户，提供专业、定制化解决方案，促成成交；<br>
            5、完成公司领导交办的其他工作内容。
          </p>
        </div>
      </div>
      <div class="explain">简历投递至：991949100@qq.com</div>
    </div>
    <el-dialog custom-class="dialog_box"
               :close-on-click-modal="false"
               :show-close="false"
               :visible.sync="dialogVisible">
      <div class="close"
           @click="dialogVisible = false"></div>
      <el-scrollbar style="height: 2.2605rem; padding:0px">
        <div class="title">
          UI设计
        </div>
        <div class="text">
          <h5>
            岗位职责：
          </h5>
          <p>
            1、负责公司产品的界面进行设计、编辑、美化等工作；<br>
            3、对公司的宣传产品进行美工设计；<br>
            4、负责客户及系统内的广告和专题的设计；<br>
            5、负责与开发人员配合完成所辖网站等前台页面设计和编辑；<br>
            6、其他与美术设计相关的工作。
          </p>
          <h5>
            任职资格：
          </h5>
          <p>
            1、美术、平面设计相关专业，专科及以上学历；<br>
            2、两年以上网页设计及平面设计工作经验；<br>
            3、有扎实的美术功底、良好的创意思维和理解能力，能及时把握客户需求；<br>
            4、精通Photoshop\Dreamweaver\Illustrator\XD\墨刀等设计软件，对图片
            渲染和视觉效果有较好认识。
          </p>
        </div>
      </el-scrollbar>

    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Banner,
    Footer,
  },
  data () {
    return {
      dialogVisible: false,

    }
  }
}
</script>

<style lang="scss" scoped>
.recruit {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .recruit_box {
    background-image: url("../../static/images/img/JPINUS.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .recruit_li {
      position: relative;
      width: 1.9479rem - 0.1563rem;
      height: 1.5677rem - 0.1563rem;
      padding: 0.1563rem;
      background-color: #fff;
      box-shadow: 0px 0px 0.1042rem rgba(0, 0, 0, 0.2);
      text-align: left;
      margin-top: 0.3125rem;
      .title {
        font-size: 0.1042rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0.1667rem;
        color: #333333;
        letter-spacing: 0.0104rem;
        opacity: 1;
      }
      p {
        font-size: 0.0833rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0.1563rem;
        color: #999999;
        opacity: 1;
        margin-top: 0.0521rem;
      }
      .info {
        text-align: center;
        position: absolute;
        background-image: url("../../static/images/img/chakanxiangqing.png");
        background-size: 115% 100%;
        width: 0.4688rem;
        height: 0.3829rem;
        bottom: 0rem;
        right: 0rem;
        font-size: 0.0833rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0.4629rem;
        padding-left: 0.0521rem;
        color: #ffffff;
        opacity: 1;
        cursor: pointer;
        user-select: none;
      }
    }
    .recruit_li:nth-child(1) {
      margin-top: 0rem;
    }
    .recruit_li:nth-child(2) {
      margin-top: 0rem;
    }
  }
  .explain {
    width: 2.651rem;
    height: 0.3021rem;
    background: #ff6100;
    border: 0.0052rem solid rgba(165, 163, 163, 0.49019607843137253);
    opacity: 1;
    border-radius: 0.1823rem;
    margin: 0.2708rem auto;
    font-size: 0.1042rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 0.3021rem;
    color: #ffffff;
    letter-spacing: 0.0104rem;
    opacity: 1;
  }
}
</style>
<style lang="scss">
.dialog_box {
  position: relative;
  background-color: pink !important;
  border-radius: 0.1563rem;
  width: 3.2813rem;
  height: 2.6771rem;
  padding: 0.2083rem;
  background-image: url("../../static/images/img/tankaungditu.png");
  background-size: 115% 115%;
  background-position: center;
  background-repeat: no-repeat;
  .close {
    position: absolute;
    width: 0.2604rem;
    height: 0.2604rem;
    bottom: -0.5563rem;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    background-image: url("../../static/images/img/closeguanbi.png");
    background-size: 100% 100%;
    border-radius: 50%;
  }
  .title {
    font-size: 0.1563rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 0.1667rem;
    color: #000000;
    letter-spacing: 0.0104rem;
    opacity: 1;
  }
  .text {
    text-align: left;
    font-size: 0.0833rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 0.1563rem;
    color: #444444;
    opacity: 1;
    margin-top: 0.1563rem;
    h5 {
      font-size: 0.0833rem;
    }
    p {
      font-size: 0.0833rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.1563rem;
      color: #999999;
      opacity: 1;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0px;
  }
}
</style>